import dayjs from 'dayjs';

const startOfDay = dayjs().startOf('day');

export const isActionExpired = (deadlineString: string): boolean => {
	const deadline = deadlineString ? dayjs(deadlineString) : null;
	return deadline != null && deadline.isBefore(startOfDay);
};
